export const getCurrentTimestamp = () => +new Date();
//# sourceMappingURL=getCurrentTimestamp.js.map